import $ from "jquery";
import {css} from "@emotion/core";
import * as moment from "moment";
import axios from "axios";
import config from 'react-global-configuration';
export const reactSelectStyles = {
    control: provided => ({
        ...provided,
        padding:"0px",
        minHeight: "32px",
    }),
    indicatorsContainer: provided => ({
        ...provided,
        height: "35px"
    }),
    clearIndicator: provided => ({
        ...provided,
        padding: "5px"
    }),
    dropdownIndicator: provided => ({
        ...provided,
        padding: "5px"
    }),
    valueContainer: base => ({
        ...base,
        padding: '0px 6px'
    }),
    menu: styles => ({ ...styles, zIndex: 999 })
};

export const override = css `
    display: block;
    margin: 0 auto;
    border-color: red;
    text-align:center;
`;

export const isApiResponse = (flag) => {
    if(flag===false) {
        $('body').addClass("back-disabled");
    } else {
        $('body').removeClass("back-disabled");
    }
};

export const isReportAccess = (decoded_permission, report_name) => {
    let reportPermissions = [];
    decoded_permission.map((permissionName, i) => {
        if(permissionName.access_type=='report'){
            reportPermissions.push(permissionName.access_name);
        }
    });
    if(reportPermissions.includes(report_name)===false ){
        unauthorize_access();
    }
}

export const unauthorize_access = () =>
{
    localStorage.removeItem("usertoken");
    localStorage.removeItem("userPermission");
    alert("Unauthorized Access");
    window.location.href = "/";
}

export const date_range_config = (default_start_date, default_end_date,start_date_limit,end_date_limit) =>
{
    var start_selected_date = new Date(Date.now() - default_start_date*24*60*60*1000);
    var end_selected_date = new Date(Date.now() - default_end_date*24*60*60*1000);
    var end_limit = new Date(Date.now() - end_date_limit*24*60*60*1000);
    var start_date = moment(start_selected_date).format('MM/DD/YYYY');
    var end_date = moment(end_selected_date).format('MM/DD/YYYY');
    var display_start_date = moment(start_selected_date).format('D MMM YYYY');
    var display_end_date = moment(end_selected_date).format('D MMM YYYY');
    var start_date_value = moment(start_selected_date).format('YYYY-MM-DD');
    var end_date_value = moment(end_selected_date).format('YYYY-MM-DD');
    var end_date_limit = moment(end_limit).format('MM/DD/YYYY');
    var start_date_limit = moment(start_date_limit).format('MM/DD/YYYY');
    var date_config = {
        start_date: start_date,
        end_date: end_date,
        display_start_date: display_start_date,
        display_end_date: display_end_date,
        start_date_value: start_date_value,
        end_date_value: end_date_value,
        end_date_limit: end_date_limit,
        start_date_limit: start_date_limit
    }
    return date_config;

}

export const compareValues = (val1, val2) => {
    if(Array.isArray(val1) && Array.isArray(val2)) {
        if(val1.length===val2.length){
            var is_unique = val1.every(i => val2.includes(i));
            if(is_unique===true){
                return true;
            } else {
                return true;
            }
        }
        else{
            return true;
        }

    } else {
        if(val1===val2){
            return true;
        } else {
            return true;
        }
    }
}
export const aplloClient = ["IAPO0213","IAPO0238","I00585","IAPO0274","IAPO0303","I00937","IAPO0392","I03011","APO0454","I03274","IAPO0393","I03010","SIND0192","SIND0257","S00595","IAPO0213","IAPO0260","I00628","IAPO0170","IAPO0196","I00538","IAPO0213","IAPO0398","I03013","IAPO0223","IAPO0246","I00616","SAPO0202","SAPO0269","S01388","IAPO0466","I03283","SIND0192","SIND0257","S00649","IAPO0394","I03012","IAPO0221","IAPO0244","I00615"]

export const formatNumber = (num) => {
    //return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
    var n1, n2;
    num = num + '' || '';
    // works for integer and floating as well
    n1 = num.split('.');
    n2 = n1[1] || null;
    n1 = n1[0].replace(/(\d)(?=(\d\d)+\d$)/g, "$1,");
    num = n2 ? n1 + '.' + n2 : n1;
    return num;
}

export const numDifferentiation = (val, amount_type) => {
    if(amount_type==='Thousand'){
        if(val >= 1000) val = (val/1000).toFixed(2) + ' K';
        if(val>0 && val<1000) val = val.toFixed(1);
    }
    if(amount_type==='Lakhs'){
        if(val >= 100000) val = (val/100000).toFixed(2) + ' L';
        if(val >= 1000) val = (val/1000).toFixed(2) + ' K';
        if(val>0 && val<1000) val = val.toFixed(1);
    }
    return val;
}

export const lastTenDaysColumn = () => {
    var lastTenDays = [];
    for (var i = 0; i <= 9; i++) {
        var date = new Date(Date.now() -i*24*60*60*1000);
        var dateFormat = moment(date).format('YYYY-MM-DD');
        lastTenDays.push(dateFormat)
    }
    return lastTenDays;
}

export const lastTenWeeksColumn = () => {
    var lastTenWeeks = [];
    var curr_start = moment().startOf('isoWeek').format("YYYY-MM-DD");
    var curr_end = moment().endOf("isoWeek").format("YYYY-MM-DD");

    lastTenWeeks.push(curr_start + ' to ' + curr_end)
    for (var i = 1; i <= 9; i++) {
        var cr = moment().subtract(i, 'weeks').startOf('isoWeek').format("YYYY-MM-DD");
        var ce = moment().subtract(i, 'weeks').endOf('isoWeek').format("YYYY-MM-DD");

        lastTenWeeks.push(cr + ' to ' + ce)
    }
    return lastTenWeeks;
}

export const lastTenMonthsColumn = () => {
    var lastTenMonths = [];
    var curr_start = moment().startOf('month').format("YYYY-MM-DD");
    var curr_end = moment().endOf("month").format("YYYY-MM-DD");

    lastTenMonths.push(curr_start + ' to ' + curr_end)
    for (var i = 1; i <= 5; i++) {
        var cr = moment().subtract(i, 'months').startOf('month').format("YYYY-MM-DD");
        var ce = moment().subtract(i, 'months').endOf('month').format("YYYY-MM-DD");

        lastTenMonths.push(cr + ' to ' + ce)
    }
    return lastTenMonths;
}

export const lastTenMonthsEMIColumn = () => {
    var lastTenDays = [];
    var lastTenDaysCount = [];
    for (var i = 1; i <= 5; i++) {
        var date = new Date(Date.now() - i * 24 * 60 * 60 * 1000);
        var dateFormat = moment().subtract(i, 'months').startOf('month').format("YYYY-MM-DD") + ' to ' + moment().subtract(i, 'months').endOf('month').format("YYYY-MM-DD") + '_Total Transaction Amount';
        var dateFormat1 = moment().subtract(i, 'months').startOf('month').format("YYYY-MM-DD") + ' to ' + moment().subtract(i, 'months').endOf('month').format("YYYY-MM-DD") + '_Total Cashback Amount';
        lastTenDays.push(dateFormat);
        lastTenDays.push(dateFormat1);

        var dateFormatCount = moment().subtract(i, 'months').startOf('month').format("YYYY-MM-DD") + ' to ' + moment().subtract(i, 'months').endOf('month').format("YYYY-MM-DD") + '_Total Transaction Count';
        var dateFormat1Count = moment().subtract(i, 'months').startOf('month').format("YYYY-MM-DD") + ' to ' + moment().subtract(i, 'months').endOf('month').format("YYYY-MM-DD") + '_Total Cashback Count';
        lastTenDaysCount.push(dateFormatCount);
        lastTenDaysCount.push(dateFormat1Count);
    }
    var columns_config = {
        lastTenDaysCount:lastTenDaysCount,
        lastTenDays: lastTenDays
    }
    return columns_config

}

export const lastTenWeekEMIColumn = () => {
    var lastTenDays = [];
    var lastTenDaysCount = [];
    for (var i = 0; i <= 9; i++) {
        var date = new Date(Date.now() - i * 24 * 60 * 60 * 1000);
        var dateFormat = moment().subtract(i, 'weeks').startOf('isoWeek').format("YYYY-MM-DD") + ' to ' + moment().subtract(i, 'weeks').endOf('isoWeek').format("YYYY-MM-DD") + '_Total Transaction Amount';
        var dateFormat1 = moment().subtract(i, 'weeks').startOf('isoWeek').format("YYYY-MM-DD") + ' to ' + moment().subtract(i, 'weeks').endOf('isoWeek').format("YYYY-MM-DD") + '_Total Cashback Amount';
        lastTenDays.push(dateFormat);
        lastTenDays.push(dateFormat1);

        var dateFormatCount = moment().subtract(i, 'weeks').startOf('isoWeek').format("YYYY-MM-DD") + ' to ' + moment().subtract(i, 'weeks').endOf('isoWeek').format("YYYY-MM-DD") + '_Total Transaction Count';
        var dateFormat1Count = moment().subtract(i, 'weeks').startOf('isoWeek').format("YYYY-MM-DD") + ' to ' + moment().subtract(i, 'weeks').endOf('isoWeek').format("YYYY-MM-DD") + '_Total Cashback Count';
        lastTenDaysCount.push(dateFormatCount);
        lastTenDaysCount.push(dateFormat1Count);
    }
    var columns_config = {
        lastTenDaysCount:lastTenDaysCount,
        lastTenDays: lastTenDays
    }
    return columns_config

}

export const user_activities = (view_id, user_id, user_name, email,sparcs_report_code,report_type) => {
    // alert(view_id); alert(user_id); alert(user_name); alert(email);
    axios.post(config.get('API_URL')+'/tableau/user-activities/',{
            view_id: view_id,
            user_id: user_id,
            user_name: user_name,
            email: email,
            sparcs_report_code:sparcs_report_code,
            report_type:report_type
        },
        {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        }).then(response => {
        return response;
    });
    //return val;
}

export const check_tableau_report_permission = (user_department, project_id, workbook_id, worksheet_id) => {
    // alert(view_id); alert(user_id); alert(user_name); alert(email);
    axios.post(config.get('API_URL')+'/tableau/check-tableau-report-access/',{
            project_id: project_id,
            user_department: user_department,
            workbook_id: workbook_id,
            worksheet_id: worksheet_id
        },
        {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        }).then(response => {
        if(response.data.length<1) {
            unauthorize_access();
        }
        return response;
    });
    //return val;
}

export const numDifferentiationRoi = (val) => {
//    if(amount_type==='Thousand'){
//        if(val >= 1000) val = (val/1000).toFixed(2) + ' K';
//        if(val>0 && val<1000) val = val.toFixed(1);
//    }
//    if(amount_type==='Lakhs'){
//        if(val >= 100000)
//        {
//            val = (val/100000).toFixed(2) + ' L';
//        }
//        else {
//
//        }
//        if(val >= 1000) val = (val/1000).toFixed(2) + ' K';
//        if(val>0 && val<1000) val = val.toFixed(1);
//    }
    return val;
}